<template>
	<div id="app">
		<el-container style="height: 100vh;">
			<!-- 顶部区域 -->
			<el-header height="418" class="header-background animate__animated animate__fadeInDown">
				<div class="header-content">
					<img src="../../assets/img/fajs/slogan.png" class="slogan-img" />
					<el-button type="primary" class="contact-button" @click="handleContactUs">
						联系我们
					</el-button>
				</div>
			</el-header>
			<el-header height="200" class="header2 animate__animated animate__fadeInLeft">
				<p class="p1">全部解决方案</p>
				<p class="p2">ALL SOLUTIONS</p>
			</el-header>

			<!-- 主体区域 -->
			<el-container class="container-body animate__animated animate__fadeInUp">
				<!-- 左侧导航栏 -->
				<el-aside width="200px" class="aside-menu">
					<el-menu :default-active="activeMenu" @select="handleSelect">
						<el-menu-item index="1">气象大数据</el-menu-item>
						<el-menu-item index="2">水库综合管理</el-menu-item>
						<el-menu-item index="3">智慧环保</el-menu-item>
						<el-menu-item index="4">智慧水利</el-menu-item>
						<el-menu-item index="5">智慧水务</el-menu-item>
						<el-menu-item index="6">智慧防汛</el-menu-item>
						<el-menu-item index="7">多灾害综合应急管理平台</el-menu-item>
					</el-menu>
				</el-aside>

				<!-- 内容区域 -->
				<el-main>
					<div class="content">
						<!-- 根据 activeMenu 动态显示内容 -->
						<template v-if="activeMenu === '1'">
							<h2>气象大数据平台</h2>
							<div class="icon-b">
								<div></div>
							</div>
							<p>
								实时整合卫星遥感、地面监测站、气象模型预测等多源数据，利用大数据处理技术和机器学习算法，实现对气象信息的精准捕捉与深度分析，为防汛决策争取黄金时间。</p>
							<img src="../../assets/img/fajs/jp_qxdsj.png" class="jp-img" />
						</template>

						<template v-if="activeMenu === '2'">
							<h2>水库综合管理</h2>
							<div class="icon-b">
								<div></div>
							</div>
							<p>
								实时整合卫星遥感、地面监测站、气象模型预测等多源数据，利用大数据处理技术和机器学习算法，实现对气象信息的精准捕捉与深度分析，为防汛决策争取黄金时间。</p>
							<img src="../../assets/img/fajs/jp_skzhgl.png" class="jp-img" />
						</template>

						<template v-if="activeMenu === '3'">
							<h2>智慧环保</h2>
							<div class="icon-b">
								<div></div>
							</div>
							<p>
								智慧环保利用传感器网络、大数据分析和人工智能技术，对水环境、水生态和污染源进行实时监测和智能分析。通过对园区企业的污水排放进行实时监测，运用大数据分析技术对环境质量变化趋势进行预测，可及时发现和处理环境污染问题，促进园区的绿色可持续发展。
							</p>
							<img src="../../assets/img/fajs/jp_zhhb.png" class="jp-img" />
						</template>

						<template v-if="activeMenu === '4'">
							<h2>智慧水利</h2>
							<div class="icon-b">
								<div></div>
							</div>
							<p>
								智慧水利平台是水利行业数字化转型的核心支撑。整合了水利工程建设、运行管理、水资源调配等业务，运用
								BIM（建筑信息模型）、GIS、物联网等技术，实现水利工程的全生命周期管理和水资源的精细化管理。</p>
							<img src="../../assets/img/fajs/jp_zhsl.png" class="jp-img" />
						</template>

						<template v-if="activeMenu === '5'">
							<h2>智慧水务</h2>
							<div class="icon-b">
								<div></div>
							</div>
							<p>
								智慧水务综合管理平台是水利信息化的集成枢纽。融合物联网、大数据、云计算、人工智能等技术，实现水务业务的全面数字化和智能化。涵盖水资源管理、供水、排水、污水处理等多个环节，通过数据共享和业务协同，可提高水务管理的效率和决策的科学性。
							</p>
							<img src="../../assets/img/fajs/jp_zhsw.png" class="jp-img" />
						</template>

						<template v-if="activeMenu === '6'">
							<h2>智慧防汛</h2>
							<div class="icon-b">
								<div></div>
							</div>
							<p>
								智慧防汛通过融合卫星遥感、无人机监测、气象水文预报和大数据分析技术，实现对汛情的实时监测、精准预测和科学指挥。通过实时获取雨情、水情、工情数据，运用大数据分析技术对汛情进行评估和预测，为防汛指挥决策提供科学依据，有效保障流域内人民群众的生命财产安全。
							</p>
							<img src="../../assets/img/fajs/jp_zhfx.png" class="jp-img" />
						</template>

						<template v-if="activeMenu === '7'">
							<h2>多灾害综合应急管理平台</h2>
							<div class="icon-b">
								<div></div>
							</div>
							<p>
								多灾害应急管理平台集成气象灾害、地质灾害、水利灾害等多种灾害的监测预警、应急响应和救援指挥功能，运用大数据、人工智能和通信技术，实现多灾害的协同管理和高效应对。融合洪涝、地震、滑坡等多灾种模型，一键生成跨部门协同预案，应急资源调度响应时间缩短至15分钟。
							</p>
							<img src="../../assets/img/fajs/jp_dzzhyj.png" class="jp-img" />
						</template>
					</div>
				</el-main>
			</el-container>
		</el-container>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeMenu: '1', // 默认选中的菜单项
			};
		},
		methods: {
			handleContactUs() {
				//alert('点击了“联系我们”按钮');
			},
			handleSelect(index) {
				this.activeMenu = index; // 更新选中的菜单项
				console.log('当前选中的菜单项:', index);
			},
		},
	};
</script>

<style scoped>
	/* 顶部背景样式 */
	.header-background {
		background-image: url('../../assets/img/fajs/ggbj.png');
		background-size: cover;
		background-position: center;
		display: flex;
		align-items: center;
		text-align: center;
	}

	.header-content {
		display: flex;
		flex-direction: column;
		align-items: center;
		height: 100%;
	}

	.header-content img,
	.header-content button {
		margin-left: 280px;
	}

	.header-content button {
		border-radius: 0;
		background-color: #35CBF7;
	}

	/* 顶部内容样式 */
	.slogan-img {
		width: 300px;
		margin: 100px auto 50px;
	}

	.contact-button {
		margin-bottom: 50px;
	}

	/* 左侧导航栏样式 */
	.aside-menu {
		background-color: #14172E;
	}

	.aside-menu .el-menu,
	.aside-menu .el-menu-item {
		background-color: #14172E;
		color: white;
	}

	.aside-menu .el-menu {
		border-right: 1px solid #30344D;
	}

	.aside-menu .el-menu-item.is-active {
		color: #35CBF7;
		border-left: 6px #35CBF7 solid;
	}

	.aside-menu .el-menu-item {
		margin-top: 29px;
	}

	/* 主体内容样式 */
	.content {
		padding: 20px;
		text-align: center;
	}

	.content h2 {
		margin: 0 0 10px;
		color: white;
	}

	.content p {
		color: #afafaf;
		height: 50px;
	}

	.jp-img,
	.content h2,
	.content p,
	.icon-b {
		width: 756px;
		margin: 20px auto;
		text-align: left;
	}

	.header2 .p1,
	.header2 .p2 {
		color: white;
		font-family: PingFang SC, sans-serif;
		font-weight: 400;
	}

	.header2 .p1 {
		font-size: 37px;
		margin-top: 50px;
	}

	.header2 .p2 {
		font-size: 24px;
		letter-spacing: 3px;
		margin-bottom: 50px;
	}

	/* 容器主体样式 */
	.container-body {
		margin: 0 280px;
		border: 1px solid #30344D;
		background-color: #0E1021;
	}

	.icon-b div {
		border-bottom: 2px #35CBF7 solid;
		width: 18px;
	}
</style>
<style>
	.el-main {
		overflow: auto;
		/* 保留滚动功能 */
		scrollbar-width: none;
		/* 隐藏浏览器自带滚动条（Firefox兼容） */
		height: 100%;
		/* 确保 el-main 高度填满父级容器 */
	}

	.el-main::-webkit-scrollbar {
		display: none;
		/* 隐藏滚动条（Chrome、Safari兼容） */
	}
</style>


// WEBPACK FOOTER //
// src/components/views/Fajs.vue